import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';
import { bloxColors, bloxValues } from 'themes/constants';

// Advanced search IconButton
export const savedSearchIconButtonStyle = (theme: Theme): SystemStyleObject => ({
  m: 0,
  p: 0.5,
  borderRadius: '50%',
  fontSize: bloxValues.iconSizeRegular,
  color: theme.palette.text.secondary,
});

// Advanced search toggle icon
export const getSavedSearchIconStyle = (
  theme: Theme,
  isDefault?: boolean,
): SystemStyleObject => ({
  m: 0,
  p: 0,
  fontSize: bloxValues.iconSizeRegular,
  borderRadius: theme.shape.borderRadius,
  color: isDefault ? bloxColors.yellow : theme.palette.text.secondary,
});

export const savedSearchPrivacyStyle = (theme: Theme): SystemStyleObject => ({
  '& .MuiTypography-root': {
    display: 'flex',
    alignItems: 'center',
    fontSize: 18,
    gap: 1,
    '& .MuiSvgIcon-root': {
      width: 20,
      height: 20,
    },
  },
});
